export default __webpack_public_path__ + "static/Sprint1_Welcome_3Pillars_MOBILE-16d4ee2c0709999e8921f1b3cf4f9ea2.mp4";